/* eslint-disable vue/valid-v-slot */
import axios from '@/plugins/axios'
import alert from '@/plugins/alert'
import { Teacher, User, Teaching, Class, Document } from '@/plugins/api'

const UPLOAD_API = '/upload/'
const DESTROY_API = '/upload/files/'

export default {
  namespaced: true,
  state: {
    teacher: {},
    avatar: {},
    teachings: [],
    ownClasses: [],
    teacherUsername: '',
    teachingClassCount: 0,
    documents: []
  },
  actions: {
    async fetchTeachings({ commit }, options) {
      const teachings = await Teaching.fetch({ ...options, _limit: -1, _sort: 'tags:ASC' })
      const classes = teachings.map(t => t.class && t.class.title)
      const teachingClassCount = new Set(classes).size
      commit('changeState', { teachings, teachingClassCount })
    },
    async updateTeaching({ commit }, { id, ...teaching }) {
      await Teaching.update(id, teaching)
      commit('updateTeaching', id)
    },
    async removeTeaching({ commit }, teachingId) {
      await Teaching.remove(teachingId)
      commit('updateTeaching', teachingId)
    },
    async fetchOwnClasses({ commit, state }, options) {
      const teacher = await Teacher.fetchOne(options.teacher)
      let ownClasses = []
      for (const classData of teacher.ownClasses) {
        const c = await Class.fetchOne(classData.id)
        ownClasses = [...ownClasses, c]
      }
      commit('changeState', { ownClasses, teacher })
    },
    async fetchOneTeacher({ commit, state }, id) {
      const teacher = await Teacher.fetchOne(id)
      return teacher
    },
    updateOwnClassList({ commit }, classData) {
      commit('updateOwnClassList', classData.id)
    },
    updateTeachingList({ commit }, teaching) {
      commit('updateTeachings', teaching.id)
    },
    uploadAvatar({ commit }, formData) {
      return axios
        .post(UPLOAD_API, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then(response => {
          commit('setAvatar', response[0])
          alert.success('Upload successfully!')
        })
        .catch(e => alert.error(e))
    },
    destroyAvatar({ commit }, id) {
      return axios
        .delete(DESTROY_API + id)
        .then(staff => {
          alert.success('Remove success')
          commit('setAvatar', null)
        })
        .catch(e => alert.error(e))
    },
    async fetchTeacher({ commit }, teacherId) {
      commit('setTeacher', null)
      const teacher = await Teacher.fetchOne(teacherId)
      commit('setTeacher', teacher)
    },
    async removeTeacher({ commit }, teacher) {
      if (teacher.user) {
        await User.remove(teacher.user)
      }
      await Teacher.remove(teacher.id)
      commit('removeTeacher', teacher.id)
      alert.success('Xóa thành công!')
    },
    async updateTeacher({ commit }, { id, ...teacher }) {
      const updatedTeacher = await Teacher.update(id, teacher)
      commit('setTeacher', updatedTeacher)
      alert.success('Cập nhật thành công!')
      return updatedTeacher
    },

    setTeacherUsername({ commit }, teacherUsername) {
      commit('changeState', { teacherUsername })
    },
    async fetchTeacherDocuments({ commit }, options) {
      const documents = await Document.fetch({
        ...options,
        _sort: 'documentType.index:ASC',
        _limit: -1
      })
      commit('changeState', { documents })
    }
  },
  mutations: {
    setTeacher(state, teacher) {
      state.teacher = teacher
    },
    removeTeacher(state, teacherId) {
      state.teacher = null
    },
    setAvatar(state, avatar) {
      state.teacher = {
        ...state.teacher,
        avatar: avatar
      }
      state.avatar = avatar
    },
    updateTeachings(state, id) {
      state.teachings = state.teachings.filter(t => t.id !== id)
    },
    updateOwnClassList(state, classId) {
      state.ownClasses = state.ownClasses.filter(c => c.id !== classId)
    }
  },
  getters: {
    avatar: state => {
      return state.avatar
    }
  }
}
